/**
 * Utilidad para generar iniciales de usuario
 */
export class UserInitialsUtil {
  
  /**
   * Genera las iniciales del usuario basado en firstname y lastname
   * @param firstname - Primer nombre del usuario
   * @param lastname - Apellido del usuario
   * @param fullname - Nombre completo como fallback
   * @param defaultInitials - Iniciales por defecto si no se puede generar
   * @returns Las iniciales del usuario (ej: "JC")
   */
  static generateInitials(
    firstname?: string, 
    lastname?: string, 
    fullname?: string, 
    defaultInitials: string = 'JC'
  ): string {
    // Opción 1: Usar firstname y lastname
    if (firstname && lastname) {
      const firstInitial = firstname.trim().charAt(0).toUpperCase();
      const lastInitial = lastname.trim().charAt(0).toUpperCase();
      return firstInitial + lastInitial;
    }
    
    // Opción 2: Usar fullname como fallback
    if (fullname) {
      const names = fullname.trim().split(/\s+/); // Dividir por cualquier espacio en blanco
      
      if (names.length >= 2) {
        // Tomar primera letra del primer nombre y primera letra del último apellido
        const firstInitial = names[0].charAt(0).toUpperCase();
        const lastInitial = names[names.length - 1].charAt(0).toUpperCase();
        return firstInitial + lastInitial;
      } else if (names.length === 1 && names[0].length >= 2) {
        // Si solo hay un nombre, tomar las primeras dos letras
        const firstInitial = names[0].charAt(0).toUpperCase();
        const secondInitial = names[0].charAt(1).toUpperCase();
        return firstInitial + secondInitial;
      } else if (names.length === 1 && names[0].length === 1) {
        // Si solo hay una letra, duplicarla
        const initial = names[0].charAt(0).toUpperCase();
        return initial + initial;
      }
    }
    
    // Opción 3: Valor por defecto
    return defaultInitials;
  }
  
  /**
   * Genera las iniciales del usuario desde un objeto usuario
   * @param user - Objeto usuario con propiedades firstname, lastname, fullname
   * @param defaultInitials - Iniciales por defecto
   * @returns Las iniciales del usuario
   */
  static generateFromUser(
    user: { firstname?: string; lastname?: string; fullname?: string } | null | undefined,
    defaultInitials: string = 'JC'
  ): string {
    if (!user) {
      return defaultInitials;
    }
    
    return this.generateInitials(
      user.firstname,
      user.lastname,
      user.fullname,
      defaultInitials
    );
  }
}
